module.exports = __webpack_public_path__ + "img/edit.539d6059.svg";